import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";

var PurpleButton =
/*#__PURE__*/
function (_Vue) {
  _inherits(PurpleButton, _Vue);

  function PurpleButton() {
    _classCallCheck(this, PurpleButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(PurpleButton).apply(this, arguments));
  }

  _createClass(PurpleButton, [{
    key: "clickBotton",
    value: function clickBotton() {}
  }, {
    key: "mounted",
    value: function mounted() {}
  }]);

  return PurpleButton;
}(Vue);

tslib_1.__decorate([Prop({
  default: false
})], PurpleButton.prototype, "small", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], PurpleButton.prototype, "text", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], PurpleButton.prototype, "buttonHeight", void 0);

tslib_1.__decorate([Prop({
  default: true
})], PurpleButton.prototype, "showFree", void 0);

tslib_1.__decorate([Emit("clickBotton")], PurpleButton.prototype, "clickBotton", null);

PurpleButton = tslib_1.__decorate([Component({
  components: {
    loadingAnimaton: loadingAnimaton
  }
})], PurpleButton);
export default PurpleButton;